// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + ".fd5f212." + "f0ecd2fb" + ".chunk.js";
};